module.exports = __webpack_public_path__ + "media/images/help/workflow-3f6e89f29af9548768e0aa6eef71e33e.png";